// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZktO","badges":"styles_badges__3CqXX"};